import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { SmartadminModule } from '@shared/smartadmin.module'

import { FeedbackComponent } from '@components/feedback/feedback.component'

import { FeedbackService } from '@components/feedback/feedback.service'
import { ManageStateService } from '@shared/manage-state.service'

@NgModule({
  imports: [CommonModule, SmartadminModule],
  declarations: [FeedbackComponent],
  exports: [FeedbackComponent],
  providers: [FeedbackService, ManageStateService],
})
export class FeedbackModule {}



// WEBPACK FOOTER //
// ./src/app/components/feedback/feedback.module.ts